var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.65 5.44445C13.65 7.89905 11.6601 9.88889 9.20551 9.88889C6.75091 9.88889 4.76107 7.89905 4.76107 5.44445C4.76107 2.98984 6.75091 1 9.20551 1C11.6601 1 13.65 2.98984 13.65 5.44445Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20551 13.2222C4.90997 13.2222 1.42773 16.7044 1.42773 21H16.9833C16.9833 16.7044 13.5011 13.2222 9.20551 13.2222Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminUser);
export default __webpack_public_path__ + "static/media/admin-user.7c70b5990d3ff416e64eb629071471ca.svg";
export { ForwardRef as ReactComponent };